var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacao", $$v);
      },
      expression: "form.filters.formacao"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 3,
      "label": "Data de Realização",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataRealizacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataRealizacao", $$v);
      },
      expression: "form.filters.dataRealizacao"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarListaPresenca();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.dataRealizacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarData(item.dataRealizacao)) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarListaPresenca(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": !item.passouSeteDias && !item.presencaConcluida ? 'Preencher Lista de Presença' : item.presencaConcluida ? 'Baixar Lista de Presença' : 'Fora do prazo',
            "icon": !item.passouSeteDias && !item.presencaConcluida ? 'mdi-format-list-bulleted' : item.presencaConcluida ? 'mdi-arrow-down' : 'mdi-close',
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogPrencherListaPresenca(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarListaPresencaDialog', {
    attrs: {
      "visible": _vm.dialogPreencherListaPresenca.visible,
      "content": _vm.dialogPreencherListaPresenca.content,
      "edit": _vm.dialogPreencherListaPresenca.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogPreencherListaPresenca.close();
      },
      "onSave": function ($event) {
        return _vm.buscarListaPresenca();
      }
    }
  }), _vm.dialogVisualizarListaPresenca.visible ? _c('VisualizarListaPresencaDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarListaPresenca.visible,
      "content": _vm.dialogVisualizarListaPresenca.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarListaPresenca.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }